module.exports = __webpack_public_path__ + "img/dropdown.065b1f7f.svg";